import * as THREE from "three";
import { loadModel } from "./Loader";
import { createOutline } from "../System/OutlineShader";
import { LODGroup, registerLODGroup } from "../System/LODManager";

export class ServerModel {

    private lodGroup: LODGroup;

    constructor(id: string) {
        this.lodGroup = new LODGroup();
        // Chargement des trois versions du modèle
        this.loadModel('assets/three/SERVER/SERVER_High.gltf', 1.5, id);
        this.loadModel('assets/three/SERVER/SERVER_Medium.gltf', 1.0, id);
        this.loadModel('assets/three/SERVER/SERVER_Low.gltf', 0.0, id);

        registerLODGroup(this.lodGroup);
    }

    private loadModel(url: string, threshold: number, id: string): void {
        loadModel(
            url,
            (gltf: { scene: THREE.Object3D }): void => {
                const model = gltf.scene;
                const outline = createOutline(model);

                // Position de l'outline
                outline.position.y = -0.01;

                // Scale
                model.scale.set(1.25, 1.27, 1.25);
                outline.scale.set(1.245, 1.265, 1.245);
				model.userData.id = id;
                model.userData.type = "Server";
				model.userData.modelType = "Server"
				model.visible = false;
				outline.visible = false;
				outline.userData.isOutline = "outline"
				outline.userData.type = "Server";

				// Création d'un conteneur regroupant le modèle et son outline
                const container = new THREE.Group();
                container.add(model, outline);
                container.userData.isLODContainer = true;

                // Appliquer le layer 1 à tous les objets et modifier le matériau pour la sélection
                gltf.scene.traverse((object: THREE.Object3D): void => {
                    object.layers.set(1);
                    if (object instanceof THREE.Mesh) {
                        object.material = new THREE.MeshBasicMaterial({
                            map: (object.material as THREE.MeshStandardMaterial).map,
                        });
                    }
                });

                // Ajout du container dans le LODGroup avec le seuil défini
                this.lodGroup.addLOD(container, threshold);
            },
            (progress: ProgressEvent): void => {
                // console.log(`Progression : ${(progress.loaded / progress.total) * 100}%`);
            },
            (error: unknown): void => {
                console.error('Erreur lors du chargement du modèle GLTF :', error);
            }
        );
    }

    public getGroup(): THREE.Group {
        return this.lodGroup;
    }
}
